import defaultAxiosInstance from 'common/utils/axios/cart';

import ConfigProvider from '../../services/configProvider';

const coCartUrl = `${ConfigProvider.getValue(
  'SHOP_URL'
)}/wp-json/cocart/v1/coupon`;

export const addPromoCode = async (code: string) => {
  const { data } = await defaultAxiosInstance.post(coCartUrl, {
    coupon: code,
  });
  return data;
};

export const removePromoCode = async (code: string) => {
  const { data } = await defaultAxiosInstance.delete(coCartUrl, {
    data: {
      coupon: code,
    },
  });
  return data;
};
